export default "__VITE_ASSET__Cnae2q$$__"